import React, { useState } from 'react';
import { Grid, Tooltip } from '@mui/material';
import TopNavBar from '../../Components/TopBar/Navbar';

import Button from '@mui/material/Button';
import EigenLayer from '../../Assets/images/RestakeSVG/eigenlayer.svg';
import { ReactComponent as CircleInfoSvg } from '../../Assets/images/circle-info.svg';
import TransactionHistory from './TransactionHistory';
import { useAccount } from 'wagmi';

import Bridge from './tabs/Bridge';
import { useAirdrop } from '../Airdrop/useAirdrop';
import Withdraw from './tabs/Withdraw';
import { useTransaction } from './hooks/useTransaction';

const BridgePage = () => {
  const { airdropPoints } = useAirdrop();
  const [openOZETH, setOpenOZETH] = useState(false);
  const [openOZUSD, setOpenOZUSD] = useState(false);

  const pointsFormatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  });
  const [selectedTab, setSelectedTab] = useState('bridge');

  const { transactionList, fetchTransactionList } = useTransaction();

  return (
    <Grid
      container
      gap="50px"
      display={'flex'}
      flexDirection={'column'}
      justifyContent={'start'}
      className="leaderboard_page"
    >
      <Grid container zIndex={100}>
        <TopNavBar />
      </Grid>

      <div className="d-flex flex-col items-center gap-10 justify-center section-container">
        <Grid
          lg={8}
          md={10}
          sm={12}
          xs={11}
          display="flex"
          flexDirection="column"
          gap={'40px'}
        >
          <Grid
            item
            lg={8}
            md={10}
            sm={12}
            xs={12}
            display={'flex'}
            flexDirection={'column'}
            className="mx-auto"
          >
            <p className="landingHeading text-center">
              Staking Rewards and Airdrop Points
            </p>
          </Grid>

          <div
            className="p-3 pb-0 d-flex flex-col w-full mx-auto"
            style={{
              background:
                'linear-gradient(0deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.08)),linear-gradient(90deg, rgba(254, 221, 69, 0.12) 0%, rgba(255, 233, 133, 0.12) 30.9%, rgba(252, 157, 75, 0.12) 65.4%, rgba(250, 116, 43, 0.12) 100%)',
              borderRadius: '25px',
            }}
          >
            <Grid container justifyContent={'space-around'} >
              <Grid
                item
                xs={12}
                display={'flex'}
                flexDirection={'row'}
                justifyContent={'space-between'}
                className="w-full"
              >
                <p className="airdrop_headtext">Airdrop Points</p>
                <p className="airdrop_headtext">
                  {pointsFormatter.format(airdropPoints)}
                </p>
              </Grid>
              <Grid
                item
                className="mt-3"
                xs={12}
                display={'flex'}
                flexDirection={'row'}
                alignItems={'center'}
                justifyContent={'space-between'}
              >
                <div className="airdrop_headtext d-flex cursor-pointer gap-1">
                  <Tooltip title="30d Avg APY" placement="top">
                    <p className="airdrop_headtext cursor-pointer">
                      ETH Staking APY
                    </p>
                  </Tooltip>
                  <Tooltip
                    onClose={() => setOpenOZETH(false)}
                    open={openOZETH}
                    title="Calculated using historical 7 day average from rocketpool.net"
                    placement="top"
                  >
                    <CircleInfoSvg
                      width="12"
                      onClick={() => setOpenOZETH(true)}
                    />
                  </Tooltip>
                </div>

                <p className="airdrop_headtext">2.5%</p>
              </Grid>
              <Grid
                item
                xs={12}
                display={'flex'}
                flexDirection={'row'}
                alignItems={'center'}
                justifyContent={'space-between'}
              >
                <p className="airdrop_headtext">Plus Restaking Rewards</p>
                <Grid
                  item
                  className="mt-3"
                  display={'flex'}
                  flexDirection={'row'}
                  alignItems={'center'}
                  justifyContent={'space-between'}
                >
                  {/* <img src={Symbiotic} alt="Symbiotic" />
                  <img src={Karak} alt="Karak" /> */}
                  <img src={EigenLayer} alt="EigenLayer" />
                </Grid>
              </Grid>
              <Grid
                item
                className="mt-2"
                xs={12}
                display={'flex'}
                flexDirection={'row'}
                alignItems={'center'}
                justifyContent={'space-between'}
              >
                <div className="airdrop_headtext d-flex cursor-pointer gap-1">
                  <Tooltip title="30d Avg APY" placement="top">
                    <p className="airdrop_headtext cursor-pointer">
                      Stablecoin Staking APY
                    </p>
                  </Tooltip>
                  <Tooltip
                    onClose={() => setOpenOZUSD(false)}
                    open={openOZUSD}
                    title="Estimated compounded rate per annum based on SSR - does not represent or guarantee future results"
                    placement="top"
                  >
                    <CircleInfoSvg
                      width="12"
                      onClick={() => setOpenOZUSD(true)}
                    />
                  </Tooltip>
                </div>

                <p className="airdrop_headtext">4.5%</p>
              </Grid>
            </Grid>
          </div>
        </Grid>
        <Grid
          item
          className="BridgeContainer p-3"
          lg={8}
          md={10}
          sm={12}
          xs={12}
          display={'flex'}
          flexDirection={'column'}
          alignItems={'space-between'}
          justifyContent={'space-between'}
          gap={'30px'}
        >
          <Grid
            item
            className=""
            lg={12}
            md={12}
            sm={12}
            xs={12}
            display={'flex'}
            flexDirection={'row'}
            alignItems={'flex-start'}
            justifyContent={'flex-start'}
          >
            <Button
              className="mr-2"
              sx={{
                height: '40px',
                width: 'auto',
                background:
                  selectedTab === 'bridge'
                    ? 'linear-gradient(90deg, rgba(241, 215, 75, 0.8) 0%, rgba(221, 113, 42, 0.8) 65.9%)'
                    : 'transparent',
                border: 0.75,
                borderColor: '#FC9D4B',
                borderRadius: '25px',
                color: '#FFFFFF',
                fontWeight: 'semibold',
                fontFamily: 'PoppinsRegular',
                fontSize: {
                  xs: '10px', // For extra small screens (mobile)
                  sm: '16px', // For small screens (tablets)
                  md: '18px', // For medium screens
                  lg: '18px', // For large screens
                },
                padding: {
                  xs: '15px', // For extra small screens
                  sm: '12px', // For small screens
                  md: '15px', // For medium screens
                },
                '&:hover': {
                  background:
                    'linear-gradient(90deg, rgba(241, 215, 75, 0.8) 0%, rgba(221, 113, 42, 0.8) 65.9%)',
                  boxShadow: '0px 0px 13px 1px #FC9D4B',
                },
                textTransform: 'none',
              }}
              onClick={() => {
                {
                  setSelectedTab('bridge');
                }
              }}
            >
              Bridge
            </Button>
            <Button
              className="mx-2"
              sx={{
                height: '40px',
                width: 'auto',
                background:
                  selectedTab === 'withdraw'
                    ? 'linear-gradient(90deg, rgba(241, 215, 75, 0.8) 0%, rgba(221, 113, 42, 0.8) 65.9%)'
                    : 'transparent',
                border: 0.75,
                borderColor: '#FC9D4B',
                borderRadius: '25px',
                color: '#FFFFFF',
                fontWeight: 'semibold',
                fontFamily: 'PoppinsRegular',
                fontSize: {
                  xs: '10px', // For extra small screens (mobile)
                  sm: '16px', // For small screens (tablets)
                  md: '18px', // For medium screens
                  lg: '18px', // For large screens
                },
                padding: {
                  xs: '10px', // For extra small screens
                  sm: '12px', // For small screens
                  md: '15px', // For medium screens
                },
                '&:hover': {
                  background:
                    'linear-gradient(90deg, rgba(241, 215, 75, 0.8) 0%, rgba(221, 113, 42, 0.8) 65.9%)',
                  boxShadow: '0px 0px 13px 1px #FC9D4B',
                },
                textTransform: 'none',
              }}
              onClick={() => {
                setSelectedTab('withdraw');
              }}
            >
              Withdraw
            </Button>
            <Button
              className="mx-2"
              sx={{
                height: '40px',
                width: 'auto',
                background:
                  selectedTab === 'history'
                    ? 'linear-gradient(90deg, rgba(241, 215, 75, 0.8) 0%, rgba(221, 113, 42, 0.8) 65.9%)'
                    : 'transparent',
                border: 0.75,
                borderColor: '#FC9D4B',
                borderRadius: '25px',
                color: '#FFFFFF',
                fontWeight: 'semibold',
                fontFamily: 'PoppinsRegular',
                fontSize: {
                  xs: '10px', // For extra small screens (mobile)
                  sm: '16px', // For small screens (tablets)
                  md: '18px', // For medium screens
                  lg: '18px', // For large screens
                },
                padding: {
                  xs: '10px', // For extra small screens
                  sm: '12px', // For small screens
                  md: '15px', // For medium screens
                },
                '&:hover': {
                  background:
                    'linear-gradient(90deg, rgba(241, 215, 75, 0.8) 0%, rgba(221, 113, 42, 0.8) 65.9%)',
                  boxShadow: '0px 0px 13px 1px #FC9D4B',
                },
                textTransform: 'none',
              }}
              onClick={() => {
                fetchTransactionList();
                setSelectedTab('history');
              }}
            >
              History
            </Button>
          </Grid>
          <Grid
            item
            lg={12}
            md={12}
            flexDirection={'column'}
            alignItems={'center'}
            justifyContent={'center'}
            className="w-full"
          >
            <p className="text-center ">
              Questions? Access the Docs Here on{' '}
              {selectedTab !== 'withdraw' && (
                <>
                  <a
                    href="https://docs.openzk.net/phase-1/bridging-assets-to-openzk"
                    target="_blank"
                    className="landingPtag2"
                  >
                    {' '}
                    Staking{' '}
                  </a>{' '}
                  and{' '}
                </>
              )}
              <a
                href="https://docs.openzk.net/phase-1/withdrawing-assets-from-openzk"
                target="_blank"
                className="landingPtag2"
              >
                Withdrawals{' '}
              </a>
            </p>{' '}
          </Grid>

          {selectedTab === 'bridge' ? (
            <Bridge />
          ) : selectedTab == 'withdraw' ? (
            <Withdraw />
          ) : selectedTab == 'history' ? (
            <TransactionHistory Transactions={transactionList} />
          ) : (
            ''
          )}
        </Grid>
      </div>
    </Grid>
  );
};

export default BridgePage;
